import { render } from "./FolderElementFlickr.vue?vue&type=template&id=25537d0c&scoped=true"
import script from "./FolderElementFlickr.vue?vue&type=script&lang=js"
export * from "./FolderElementFlickr.vue?vue&type=script&lang=js"

import "./FolderElementFlickr.vue?vue&type=style&index=0&id=25537d0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25537d0c"]])

export default __exports__